import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Row, Col } from 'react-flexbox-grid';
import { getCatalogueLabel, isServiceShop } from '../../utils/shopTypes';

export const Wrapper = styled.nav`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  box-shadow: 0 -1px 4px 0 rgba(0,0,0,0.15);
  z-index: 10;
`;

export const NavLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 12px;
  width: 100%;
`;

export const NavRow = styled(Row)`
  width: 100%;
  padding: 0;
  margin: 0;
`;

export const Column = styled(Col)`
  width: 100%;
  padding: 0;

  :nth-child(3){
    display: flex;
    justify-content: center;
  }
`;

export const IconWrapper = styled.div`
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 5px;
`;

class Navigation extends PureComponent {
  render() {
    const { shopTypeId } = this.props;
    const service = isServiceShop(shopTypeId);
    const catalogueLabel = getCatalogueLabel(shopTypeId);
    const catalogueIcon = service ? 'fa-concierge-bell' : 'fa-hamburger';

    return (
      <Wrapper className='is-hidden-desktop'>
        <NavRow around='xs'>
          <Column xs={2}>
            <NavLink to='/orders'>
              <IconWrapper>
                <span className={`fas ${service ? 'fa-calendar-check' : 'fa-stream'} fa-2x`} />
              </IconWrapper>
              {service ? 'Bookings' : 'Orders'}
            </NavLink>
          </Column>
          <Column xs={2}>
            <NavLink to='/partners'>
              <IconWrapper>
                <span className={`fas ${service ? 'fa-user-tie' : 'fa-motorcycle'} fa-2x`} />
              </IconWrapper>
              {service ? 'Partners' : 'Delivery'}
            </NavLink>
          </Column>
          <Column xs={2}>
            <NavLink to='/menu'>
              <IconWrapper>
                <span className={`fas ${catalogueIcon} fa-2x`} />
              </IconWrapper>
              {catalogueLabel}
            </NavLink>
          </Column>
          <Column xs={2}>
            <NavLink to='/guide'>
              <IconWrapper>
                <span className='fas fa-question-circle fa-2x' />
              </IconWrapper>
              Guide
            </NavLink>
          </Column>
          <Column xs={2}>
            <NavLink to='/settings/update'>
              <IconWrapper>
                <span className='fas fa-cog fa-2x' />
              </IconWrapper>
              Settings
            </NavLink>
          </Column>
        </NavRow>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  shopTypeId: state.dashboard && state.dashboard.shopTypeId,
});

export default connect(mapStateToProps)(Navigation);
